import { useEffect } from 'react'
import { useDrag } from 'hooks/drag'

export const useDragToUpload = ({ ref, setUploading }) => {
    const [localDrag, setLocalDrag] = useDrag(ref.current)
    const [globalDrag, setGlobalDrag] = useDrag()

    useEffect(() => {
        !!localDrag && setUploading(true)
        !globalDrag && setUploading(false)
    }, [localDrag, globalDrag])

    return {
        resetLocalDrag: () => setLocalDrag(false),
        resetGlobalDrag: () => setGlobalDrag(false)
    }
}